
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curso/[course]/[module]",
      function () {
        return require("private-next-pages/curso/[course]/[module]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curso/[course]/[module]"])
      });
    }
  